<script setup>
import ModuleContentCard from '@/components/cards/moduleContentCard/ModuleContentCard.vue';
import { isItemNow } from '@/utils/helpers';
import { isToday } from 'date-fns';

defineProps({
  backgroundColor: {
    required: true,
    default: 'red',
  },
  shouldShowDate: {
    type: Boolean,
    default: true,
  },
  shouldShowInfoTag: {
    type: Boolean,
    default: true,
  },
  shouldShowMediaCount: {
    type: Boolean,
    default: false,
  },
  content: {
    required: true,
    type: [
      {
        imgSrc: {
          type: String,
          required: true,
        },
        title: {
          type: String,
          required: true,
        },
        date: {
          type: String,
          required: true,
        },
        startdate: {
          type: String,
          required: true,
        },
        endDate: {
          type: String,
          required: true,
        },
        cancelled: {
          type: Boolean,
          required: false,
          default: false,
        },
      },
    ],
  },
});

const emit = defineEmits(['entry-item-clicked']);
</script>

<template>
  <div
    class="grid grid-cols-[repeat(3,328px)] grid-rows-[repeat(auto-fill,minmax(478px, auto)] gap-6 p-6 bg-neutral-100"
    :style="{ gridAutoRows: '478px' }"
  >
    <ModuleContentCard
      v-for="item in content"
      data-pressable
      @click="emit('entry-item-clicked', item)"
      :key="`content-card-${item.id}`"
      :backgroundColor="backgroundColor"
      :shouldShowInfoTag="shouldShowInfoTag"
      :shouldShowMediaCount="shouldShowMediaCount"
      :shouldShowDate="shouldShowDate"
      :imgSrc="item.coverImage.source"
      :title="item.title"
      :date="item.startDate"
      :isCancelled="item.cancelled"
      :isToday="isToday(item.startDate, item.endDate)"
      :isNow="isItemNow(item.startDate, item.endDate)"
      :picturesCount="item.pictures?.length"
      :videosCount="item.videos?.length"
      :mediaCount="item.media?.length"
      :item="item"
    />
  </div>
</template>
